import * as React from 'react';

import { cn } from '@shared/utils';

interface InputProps extends Readonly<React.ComponentProps<'input'>> {
  isGenericInputGroup?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, isGenericInputGroup, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-10 w-full min-w-0 rounded-md border px-3 py-2 bg-transparent transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 text-sm',
          isGenericInputGroup
            ? ''
            : 'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-transparent aria-invalid:ring-(--error)/20 dark:aria-invalid:ring-(--error)/40 aria-invalid:border-error-border',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
